import React  from 'react';
import PropTypes from 'prop-types';

export const TextWithLineBreaks = ({text}) => {

    const convertLineBreaks = (str) => {

      return str.split('\n').map((item, index) => (
        <React.Fragment key={index}>
          {item}
          <br />
        </React.Fragment>
      ));

      };
  
    if (!(text == null || (typeof text === "string" && text.trim().length === 0))) {
        return <div>{convertLineBreaks(text)}</div>
    }
    else {
        return <></>
    }    
};
TextWithLineBreaks.propTypes = {
    text: PropTypes.array.isRequired
};
